import React, { useId } from 'react';
import styles from './AppCheckbox.module.scss';

/**
 * Design System checkbox for boolean values shown side by side (filters,
 * option lists). Same label style as AppSwitch; emits a native change event
 * (e.target = checkbox) so it works with `name` / `checked` handlers.
 *
 * Props: name, checked, onChange, label, disabled, id
 */
export default function AppCheckbox({
  name,
  checked = false,
  onChange,
  label,
  disabled = false,
  id,
}) {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <label className={styles.checkbox} htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        name={name}
        checked={!!checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
      />
      <span className={styles.box} aria-hidden="true">
        <svg viewBox="0 0 12 12" className={styles.check} focusable="false">
          <path
            d="M2 6.5 4.7 9 10 3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
